import React from "react"
import accessibleSvg from "src/utils/accessibleSvg"

export default accessibleSvg(({ children, fill, ...props }) => {
  return (
    <svg
      fill={fill ? fill : "currentColor"}
      viewBox="0 0 140 140"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {children}
      <path
        className="cls-1"
        fillRule="evenodd"
        d="M70,140a70,70,0,1,1,70-70A70,70,0,0,1,70,140ZM83.229,58.593l9.234-13.869A1.752,1.752,0,0,0,91.007,42H68.22a8.283,8.283,0,0,0-6.894,3.694L41.267,75.821A1.593,1.593,0,0,0,42.59,78.3H60.679V96.444A1.555,1.555,0,0,0,62.232,98h7.476A8.283,8.283,0,0,0,76.6,94.306l22.13-33.238a1.593,1.593,0,0,0-1.323-2.475H83.229ZM82.668,48.217L73.431,62.091a1.752,1.752,0,0,0,1.456,2.724H88.769L71.432,90.854a2.071,2.071,0,0,1-1.724.924H66.893V73.63a1.555,1.555,0,0,0-1.554-1.556H51.231L66.5,49.146a2.071,2.071,0,0,1,1.724-.923Z"
      />
    </svg>
  )
})
